import { IPhotoDataManager, IUpdateBulkAGAssetParams, IClusterConfig, ISingleClusterParams, ILimittedAssetsParams, IFavoriteParams, ImageEditParams, IDeleteAPIPayloadFormat, IBulkDownloadParams} from './iphoto_data_manager';
import { AjaxHelper } from '../../http/ajax_helper';
import { IClientConfig, IDiscoveryEndPoints } from '../data_manager/data_manager_factory';
import { AGTranslator } from '../translators/ag_translator';
import { Util } from "../../common_utils/util";
import { PhotoClusterHelper } from './photo_cluster_helper';
//import * as $ from 'jquery';
import { AGFavoritesManager} from '../photo/ag_favorites_manager';
import { IPhoto } from '../data_models/iphoto';
import { ITranslator } from '../translators/itranslator';
/**
 * This class is to interact with Gateway API endpoints of photo/photos opeartions,
 * It can be a single/list/cluster of photos
 * @export
 * @class AGPhotoManager
 * @implements {IPhotoDataManager}
 */
export class AGPhotoManager implements IPhotoDataManager {
  private translator: ITranslator;
  private discoveryEndPoints: IDiscoveryEndPoints;
  clusterHelper: PhotoClusterHelper;
  
  constructor(private config: IClientConfig) {
    this.translator = Util.getTranslatorObj(config);
    this.discoveryEndPoints = config.discoveryEndPoints;
    this.clusterHelper  = new PhotoClusterHelper();
  }

  /**
   * This methods is to get the photo cluster meta data information and first page response
   * @param {IClusterMetadataParams} clusterConfig
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  getClusterMetadata(clusterConfig: IClusterConfig): Promise<any> {
    clusterConfig = this.clusterHelper.clusterConfig = $.extend(true, this.clusterHelper.clusterConfig, clusterConfig);
    let querySring = `limit=${clusterConfig.minAssetPerCluster}&timeZoneOffset=${clusterConfig.timezoneOffset}&climit=${clusterConfig.clustersPerPage}&cskip=0&sortCriteria=${clusterConfig.sortCriteria}&favoritesView=true`;
    if(clusterConfig.sourceList){
      querySring += "&source=" + clusterConfig.sourceList;
    }
    const url = this.discoveryEndPoints.pictService + 'v1/gw/photos/cluster?' + querySring;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({requestConfig: config },
      this.translator.preparePagesData.bind(this.translator, this.clusterHelper)
    );
    return promise;
  }

  /**
   * This method is to get list of cluster of perticular page and first set Url of cluster assets
   * And converts individual photo repsonse of each cluster to a Iphoto custom format, with out disturbing the repsonse 
   * structure of the API response.
   * @param {string} pageUrl
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  getClusters(pageUrl: string): Promise<any> {
    const url = this.discoveryEndPoints.pictService + "v1/gw/photos/cluster?" + pageUrl;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({requestConfig: config },
       this.translator.translateClusters.bind(this.translator, this.clusterHelper),
       );
    return promise;
  }

  /**
   * This method is to get the photos of a individual photo cluster and nexturl to get next set of assets of the cluster
   * @param {ISingleClusterParams} params
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  getClusterAssets(params: ISingleClusterParams): Promise<any> {
    //if sourceList is present send as part of request
    if (params.sourceList) {
      params.nextUrl += "&source=" + params.sourceList;
    }
    const url =
      this.discoveryEndPoints.pictService + 'v1/gw/photos/cluster/' + params.date + "?" + params.nextUrl;
    params.nextUrl = url;
    let config = {
      url,
      type: "GET",
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({requestConfig: config }, this.translator.translateClusterAssets.bind(this.translator, params, this.clusterHelper));
    return promise;
  }

  /**
   * This method useful for edit save as scenario, where we need assets between a perticular range
   * @param {ILimittedAssetsParams} params
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  getLimittedAssets(params: ILimittedAssetsParams){
    if(params.isExpandFirstcluster) {
      params.updatedSkip = 0;
    }
    let relativeUrl = `page=${params.updatedSkip}&size=${params.updatedLimit}&sortCriteria=${params.sortCriteria}&timeZoneOffset=${this.clusterHelper.clusterConfig.timezoneOffset}`;
    //if some sources are only selected then sourceList should be given as input
    if (params.sourceList) {
      relativeUrl += "&source=" + params.sourceList;
    }
    let promise = this.getClusterAssets({
      date: params.date,
      nextUrl: relativeUrl
    });
    if(params.isExpandFirstcluster) {
      promise.then(function(response:any){
        if(response.data && response.data.entities){
          response.data.entities = response.data.entities.slice(params.noOfPhotos);
        }        
        return response;
      });
    }
    return promise;
  }

  // istanbul ignore next
  getFullAssetData(params: object): any {
    // API is not ready yet.
  }
  /**
   *This method is to update asset`s dateTaken date, caption.
   *
   * @param {IUpdateBulkAGAssetParams} data
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  updateBulkAsset(data: IUpdateBulkAGAssetParams): Promise<any> {
    const translatedPayLoad: IUpdateBulkAGAssetParams = this.translator.translateAssetBulkAPIAGPayLoad(data);
    const url = this.discoveryEndPoints.pictService + 'v1/gw/photos/bulk';
    const promise = AjaxHelper.triggerApi({requestConfig:  {url,ignoreAToken: true, type: 'POST', data: JSON.stringify(translatedPayLoad) } }, this.translator.translateAssetBulkApiAGResponse.bind(this.translator,data));    
    return promise;
  }
  /**
   * Method to toggle a particular photo as favourite.
   * @param {IFavoriteParams} reqConfig
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  favoritePhoto(reqConfig: IFavoriteParams): Promise<any> {
    const url = this.discoveryEndPoints.pictService + "v1/gw/photo/favorite"; 
    const favPayload = {
      isFavorite:reqConfig.isFavorite,
      assetId:reqConfig.assetId,
      assetSource:reqConfig.assetSource
    };
    let config = {
      url,
      type: "POST",
      ignoreAToken: true,
      data: JSON.stringify(favPayload)
    };
    const promise = AjaxHelper.triggerApi({ requestConfig: config});    
    return promise;
  }  
  /**
   * Method to update favorite images as favorite or remove it as favorite.
   * @param imageId - which is used to add/remove as favorite.
   * @param addAsFavorite - which defines whether images should be added/removed from favorites.
   */
  updateFavoriteImageIds(imageId: string,addAsFavorite: boolean) {            
    if (imageId) {
      if(addAsFavorite)//If image is removed as favorite.
        AGFavoritesManager.add(imageId)
      else 
        AGFavoritesManager.delete(imageId)     
    }      
  }
  /**
  * Method to edit a perticular image
  * We are expecting edited photo JSON as param and on sucess, we are overriding the values- if the edit mode is not saveas(New).
  * if the edited mode is saveas(New), then we are translating the response json to the agg translated photo json
  * and returning to the client.
  * @param {ImageEditParams} reqConfig
  * @returns {Promise<any>}
  * @memberof UAPhotoManager
  */
  editImage(reqConfig: ImageEditParams, photoJson: IPhoto): Promise<any> {
    
    let url = this.discoveryEndPoints.pictService + "v1/gw/photo/edit";
    const editMode = reqConfig.editMode === "saveas"? "New" : (reqConfig.editMode.charAt(0).toLocaleUpperCase() + reqConfig.editMode.slice(1));;

    let payload :any = {
      "assets": [{
        "id" :  reqConfig.id,
        "assetId" : reqConfig.assetId,
        "journalCore": reqConfig.journal,
        "operation" : editMode
      }]
    };
        
    if(reqConfig.albumId){
      url = url + "?albumId="+ reqConfig.albumId;
    }

    let config = {
      url,
      type: "POST",
      data: JSON.stringify(payload),
      ignoreAToken: true
    };
    const promise = AjaxHelper.triggerApi({ requestConfig: config}, this.translator.trnaslateAGEditedPhoto.bind(this.translator, photoJson));    
    return promise;
  }
/**
 *  Deletes single picture
 * @param pictId 
 */
  deleteSinglePict(pictId: number) {
    const url = this.discoveryEndPoints.pictService + 'v1/gw/photo/' + pictId;
    const promise = AjaxHelper.triggerApi({ requestConfig: { url: url, type: 'DELETE',ignoreAToken: true } });
    return promise;
  }


  /**
   * Method to delete multiple photos can be form same album or different album
   * @param data
   */
  deleteMultiplePicts(data: IDeleteAPIPayloadFormat): Promise<any> {
    const url = this.discoveryEndPoints.pictService + 'v1/gw/photos';
    const config = { url, type: 'DELETE', data: JSON.stringify(data),ignoreAToken: true };
    const promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }
  /**
   * Method to download photo(s) to local machine
   * @param {{ assetModels: [], zipFileName: string }} data
   * @returns {Promise<any>}
   * @memberof AGPhotoManager
   */
  getBulkDownloadHash(data: IBulkDownloadParams): Promise<any> {
    const url = this.discoveryEndPoints.pictService + 'v1/gw/photos/download';    
    const payload = this.translator.preparePayloadForDownload(data);
    const promise =  AjaxHelper.triggerApi({requestConfig: { url, type: 'POST', data: JSON.stringify(payload), ignoreAToken: true }})   
    return promise;
  }
}